/* Change this file to get your personal Porfolio */

// Website related settings
const settings = {
  isSplash: false, // Change this to true if you want to use the splash screen.
  useCustomCursor: false, // Disabled - causes lag with the premium design
  googleTrackingID: "UA-174238252-2",
};

//Home Page
const greeting = {
  title: "Hello.",
  title2: "Durvesh",
  logo_name: "<durvesh />",
  nickname: "DurvAcee / Durrr",
  full_name: "Durvesh Danve",
  subTitle:
    "Software engineer building production full-stack and frontend systems with Angular, React, and Python, leveraging agentic tools and LLM workflows.",
  resumeLink:
    "https://drive.google.com/file/d/1xzBt7G-ynPWLMMcnswvOs9FagZwxE8V8/view?usp=sharing",
  mail: "mailto:durvesh.danve@gmail.com",
};

const socialMediaLinks = {
  github: "https://github.com/DurvAcee",
  linkedin: "https://www.linkedin.com/in/durvesh22/",
  gmail: "durvesh.danve@gmail.com",
  gitlab: " ",
  facebook: " ",
  twitter: "#",
  instagram: "https://www.instagram.com/_durvesh__22/",
};

const skills = {
  data: [
    {
      title: "Full-Stack Engineering at Scale",
      fileName: "FullStackImg",
      skills: [
        "Architecting scalable web applications with React, Angular, Next.js, and TypeScript",
        "Engineering high-performance backend systems with Node.js, Python, and microservices",
        "End-to-end ownership from architecture to production deployment",
        "Performance optimization reducing load times by 70% and server costs by 40%",
        "Cloud deployment on Vercel/AWS/GCP with CI/CD pipelines and 99.9% uptime",
      ],
      softwareSkills: [
        {
          skillName: "TypeScript",
          fontAwesomeClassname: "simple-icons:typescript",
          style: {
            color: "#3178C6",
          },
        },
        {
          skillName: "JavaScript",
          fontAwesomeClassname: "simple-icons:javascript",
          style: {
            color: "#F7DF1E",
          },
        },
        {
          skillName: "React",
          fontAwesomeClassname: "simple-icons:react",
          style: {
            color: "#61DAFB",
          },
        },
        {
          skillName: "Next.js",
          fontAwesomeClassname: "simple-icons:nextdotjs",
          style: {
            color: "#ffffff",
          },
        },
        {
          skillName: "Angular",
          fontAwesomeClassname: "simple-icons:angular",
          style: {
            color: "#DD0031",
          },
        },
        {
          skillName: "Node.js",
          fontAwesomeClassname: "simple-icons:nodedotjs",
          style: {
            color: "#339933",
          },
        },
        {
          skillName: "Python",
          fontAwesomeClassname: "simple-icons:python",
          style: {
            color: "#3776AB",
          },
        },
        {
          skillName: "PostgreSQL",
          fontAwesomeClassname: "simple-icons:postgresql",
          style: {
            color: "#4169E1",
          },
        },
        {
          skillName: "MongoDB",
          fontAwesomeClassname: "simple-icons:mongodb",
          style: {
            color: "#47A248",
          },
        },
        {
          skillName: "Docker",
          fontAwesomeClassname: "simple-icons:docker",
          style: {
            color: "#2496ED",
          },
        },
        {
          skillName: "AWS",
          fontAwesomeClassname: "simple-icons:amazonaws",
          style: {
            color: "#FF9900",
          },
        },
        {
          skillName: "Vercel",
          fontAwesomeClassname: "simple-icons:vercel",
          style: {
            color: "#ffffff",
          },
        },
      ],
    },
    {
      title: "AI-Powered Product Development",
      fileName: "DataScienceImg",
      skills: [
        "Building production LLM applications with RAG (Retrieval-Augmented Generation) architectures",
        "Architecting agentic workflows with Model Context Protocol (MCP), custom tools, and multi-agent systems",
        "Context engineering, prompt optimization, token compression, and structured outputs",
        "Harness engineering, deterministic evaluation suites, and agent testing frameworks",
        "Fine-tuning large language models and developing autonomous systems reducing operational overhead",
      ],
      softwareSkills: [
        {
          skillName: "MCP",
          fontAwesomeClassname: "simple-icons:anthropic",
          style: {
            backgroundColor: "transparent",
            color: "#D4A574",
          },
        },
        {
          skillName: "Agent Skills",
          fontAwesomeClassname: "simple-icons:fastapi",
          style: {
            backgroundColor: "transparent",
            color: "#009688",
          },
        },
        {
          skillName: "Context Engineering",
          fontAwesomeClassname: "simple-icons:openai",
          style: {
            backgroundColor: "transparent",
            color: "#412991",
          },
        },
        {
          skillName: "Harness Engineering",
          fontAwesomeClassname: "simple-icons:pytest",
          style: {
            backgroundColor: "transparent",
            color: "#0A9EDC",
          },
        },
        {
          skillName: "Python",
          fontAwesomeClassname: "simple-icons:python",
          style: {
            backgroundColor: "transparent",
            color: "#3776AB",
          },
        },
        {
          skillName: "LangChain",
          fontAwesomeClassname: "simple-icons:langchain",
          style: {
            backgroundColor: "transparent",
            color: "#1C3C3C",
          },
        },
        {
          skillName: "HuggingFace",
          fontAwesomeClassname: "simple-icons:huggingface",
          style: {
            backgroundColor: "transparent",
            color: "#FFD21E",
          },
        },
        {
          skillName: "PyTorch",
          fontAwesomeClassname: "simple-icons:pytorch",
          style: {
            backgroundColor: "transparent",
            color: "#EE4C2C",
          },
        },
      ],
    },
  ],
};

const degrees = {
  degrees: [
    {
      title: "MIT World Peace University",
      subtitle: "Masters in Computer Science",
      logo_path: "mit-wpu.png",
      alt_name: "MIT",
      duration: "2020 - 2022",
      descriptions: [
        "First Class Honors (GPA 3.9 / 4.0)",
        "Coursework: Artificial Intelligence, Machine Learning, Computer Systems, Cloud Computing",
        "Built full-stack software and data engineering projects with Spring, Django, and Angular",
      ],
      website_link: "https://mitwpu.edu.in/",
    },
    {
      title: "Vishwakarma Institute of Information Technology",
      subtitle: "Bachelors in Computer Science",
      logo_path: "viit.png",
      alt_name: "VIIT",
      duration: "2017 - 2020",
      descriptions: [
        "First Class with Distinction",
        "Coursework: Data Structures & Algorithms, Operating Systems, Database Management, Computer Networks, OOP",
      ],
      website_link: "https://www.viit.ac.in/",
    },
  ],
};

const certifications = {
  sections: [
    {
      title: "Generative AI & LLM Systems",
      certifications: [
        {
          title: "AI Fluency Framework & Foundations",
          subtitle: "2026",
          logo_path: "anthropic.png",
          certificate_link: "",
          alt_name: "AI Fluency",
          color_code: "#D4A574",
        },
        {
          title: "Claude Code in Action",
          subtitle: "2026",
          logo_path: "anthropic.png",
          certificate_link: "",
          alt_name: "Claude Code",
          color_code: "#D4A574",
        },
        {
          title: "Introduction to Generative AI",
          subtitle: "2024",
          logo_path: "google.png",
          certificate_link: "",
          alt_name: "Generative AI",
          color_code: "#4285F4",
        },
        {
          title: "Prompt Engineering for Developers",
          subtitle: "2024",
          logo_path: "deeplearning.png",
          certificate_link: "",
          alt_name: "Prompt Engineering",
          color_code: "#E74C5E",
        },
      ],
    },
    {
      title: "Data Science & Machine Learning",
      certifications: [
        {
          title: "Python for Data Science & AI",
          subtitle: "2021",
          logo_path: "coursera.png",
          certificate_link:
            "https://www.coursera.org/account/accomplishments/verify/PEX6M8SNT5JF",
          alt_name: "Python for Data Science & AI",
          color_code: "#47A048",
        },
        {
          title: "Machine Learning with Python",
          subtitle: "2021",
          logo_path: "coursera.png",
          certificate_link:
            "https://www.coursera.org/account/accomplishments/verify/K7G7J39N77N9",
          alt_name: "ML with Python",
          color_code: "#b190b0",
        },
        {
          title: "SQL & MySQL - Analyse and Manipulate Data",
          subtitle: "2021",
          logo_path: "udemy.png",
          certificate_link:
            "https://www.udemy.com/certificate/UC-f464f4d4-f44d-4d29-931c-852ffc3d1209/",
          alt_name: "MySQL",
          color_code: "#ffc475",
        },
      ],
    },
    {
      title: "Software Engineering & Full Stack",
      certifications: [
        {
          title: "Python Mega Course : Build 10 Real World Applications",
          subtitle: "2020",
          logo_path: "udemy.png",
          certificate_link:
            "https://www.udemy.com/certificate/UC-3a383c47-804d-481e-897d-0c4f244080cc/",
          alt_name: "Python",
          color_code: "#1e70c1",
        },
        {
          title: "Git Essentials - Learn Git with BitBucket & Sourcetree",
          subtitle: "2022",
          logo_path: "udemy.png",
          certificate_link: "",
          alt_name: "Git Essentials ",
          color_code: "#F6B808",
        },
        {
          title: "jQuery : Beginner to Advanced",
          subtitle: "2021",
          logo_path: "udemy.png",
          certificate_link:
            "https://www.udemy.com/certificate/UC-c8a61507-26b2-4914-adb4-fae4bda92e2f/",
          alt_name: "jQuery",
          color_code: "#ffbfae",
        },
      ],
    },
  ],
  certifications: [
    {
      title: "AI Fluency Framework & Foundations",
      subtitle: "2026",
      logo_path: "anthropic.png",
      certificate_link: "",
      alt_name: "AI Fluency",
      color_code: "#D4A574",
    },
    {
      title: "Claude Code in Action",
      subtitle: "2026",
      logo_path: "anthropic.png",
      certificate_link: "",
      alt_name: "Claude Code",
      color_code: "#D4A574",
    },
    {
      title: "Introduction to Generative AI",
      subtitle: "2024",
      logo_path: "google.png",
      certificate_link: "",
      alt_name: "Generative AI",
      color_code: "#4285F4",
    },
    {
      title: "Prompt Engineering for Developers",
      subtitle: "2024",
      logo_path: "deeplearning.png",
      certificate_link: "",
      alt_name: "Prompt Engineering",
      color_code: "#E74C5E",
    },
    {
      title: "Git Essentials - Learn Git with BitBucket & Sourcetree",
      subtitle: "2022",
      logo_path: "udemy.png",
      certificate_link: "",
      alt_name: "Git Essentials ",
      color_code: "#F6B808",
    },
    {
      title: "Python for Data Science & AI",
      subtitle: "2021",
      logo_path: "coursera.png",
      certificate_link:
        "https://www.coursera.org/account/accomplishments/verify/PEX6M8SNT5JF",
      alt_name: "Python for Data Science & AI",
      color_code: "#47A048",
    },
    {
      title: "SQL & MySQL - Analyse and Manipulate Data",
      subtitle: "2021",
      logo_path: "udemy.png",
      certificate_link:
        "https://www.udemy.com/certificate/UC-f464f4d4-f44d-4d29-931c-852ffc3d1209/",
      alt_name: "MySQL",
      color_code: "#ffc475",
    },
    {
      title: "Python Mega Course : Build 10 Real World Applications",
      subtitle: "2020",
      logo_path: "udemy.png",
      certificate_link:
        "https://www.udemy.com/certificate/UC-3a383c47-804d-481e-897d-0c4f244080cc/",
      alt_name: "Python",
      color_code: "#1e70c1",
    },
    {
      title: "Machine Learning with Python",
      subtitle: "2021",
      logo_path: "coursera.png",
      certificate_link:
        "https://www.coursera.org/account/accomplishments/verify/K7G7J39N77N9",
      alt_name: "ML with Python",
      color_code: "#b190b0",
    },
    {
      title: "jQuery : Beginner to Advanced",
      subtitle: "2021",
      logo_path: "udemy.png",
      certificate_link:
        "https://www.udemy.com/certificate/UC-c8a61507-26b2-4914-adb4-fae4bda92e2f/",
      alt_name: "jQuery",
      color_code: "#ffbfae",
    },
  ],
};

// Experience Page
const experience = {
  title: "Experience",
  subtitle: "Work, Internship, Awards & Publications",
  description:
    "I am currently working as a Software Engineer. I love building powerful applications, solving problems and providing top-notch solutions.",
  header_image_path: "experience.svg",
  sections: [
    {
      title: "Work",
      experiences: [
        {
          title: "Software Engineer II",
          company: "Cohesity",
          company_url: "https://www.cohesity.com/",
          logo_path: "cohesity.png",
          duration: "Dec 2024 - Present",
          location: "Pune, Maharashtra, India · Hybrid",
          metrics: [
            "10k+ Tenant Clusters",
            "-60% Load Latency",
            "MCP / AI SDLC",
          ],
          description:
            "Led frontend architecture decisions around component boundaries, state management, data-fetching patterns, and rendering strategies. Optimized critical UI flows by reducing bundle size, improving rendering performance, and lowering interaction latency under heavy data loads. Built production-grade Angular and TypeScript applications with strict performance, accessibility, and reliability requirements. Collaborate closely with cross-functional teams to deliver roadmap-critical features across hybrid and multi-cloud environments.",
          color: "#009e60",
        },
        {
          title: "Software Engineer I",
          company: "Veritas Technologies LLC",
          company_url: "https://www.veritas.com/",
          logo_path: "veritas.png",
          duration: "Sep 2023 - Dec 2024",
          location: "Pune, Maharashtra, India · Hybrid",
          metrics: [
            "100k Records Virtualized",
            "$1B+ ARR NetBackup",
            "WCAG 2.1 AA Tokens",
          ],
          description:
            "Delivered and owned core features for NetBackup and Alta, $1B+ ARR enterprise data protection platforms. Designed and maintained scalable Angular and TypeScript applications used by large enterprise customer deployments. Improved frontend performance by ~30% through bundle size reduction and critical rendering path optimization. Built reusable, accessible UI component libraries with Angular Material, standardizing UX across teams. Automated Bitbucket-based code review and CI workflows, improving engineering velocity and review throughput by ~40%. Performed architectural and code reviews; mentored junior engineers on system design and performance tradeoffs.",
          color: "#2962FF",
        },
        {
          title: "Assoc IT Developer",
          company: "Veritas Technologies LLC",
          company_url: "https://www.veritas.com/",
          logo_path: "veritas.png",
          duration: "Jul 2022 - Sep 2023",
          location: "Pune, Maharashtra, India · Hybrid",
          metrics: [
            "15+ Production Features",
            "AEM / Java",
            "Security Hardening",
          ],
          description:
            "Developed and owned enterprise web features using Angular, TypeScript, and REST APIs in Agile delivery cycles. Built and maintained Adobe Experience Manager (AEM) components using Java, HTML, CSS, and JavaScript. Identified and resolved high-impact security vulnerabilities, strengthening compliance and platform reliability. Delivered 15+ production features with consistent on-time execution.",
          color: "#2962FF",
        },
      ],
    },
    {
      title: "Internships",
      experiences: [
        {
          title: "IT Developer Intern",
          company: "Veritas",
          company_url: "https://www.veritas.com/",
          logo_path: "veritas.png",
          duration: "Jan 2022 - Jun 2022",
          location: "Pune, Maharashtra, India · On-site",
          metrics: ["AEM Support Portal", "Git / CI Workflow"],
          description:
            "Contributed on Re-Vamping the Look & Feel of Customer Support Portal of Veritas. Developed Dynamic and Responsive Key Components in AEM (Adobe Experience Manager) using HTML, CSS3, JavaScript, jQuery (Front-end) and Java (Back-end). Adopted Agile Development Methodology using JIRA & Version control system using Git & Bitbucket.",
          color: "#0071C5",
        },
        {
          title: "AI Engineer intern",
          company: "BITS Robotech",
          company_url: " ",
          logo_path: "buld.jpg",
          duration: "May 2021 - Jul 2021",
          location: "Pune, Maharashtra, India · Remote",
          metrics: ["85% NLP Intent Acc", "1k+ Concurrent Proctoring"],
          description:
            "Developed a production-ready Python-based NLP chatbot achieving ~85% intent classification accuracy. Built an AI-driven online proctoring system supporting 1,000+ concurrent exam sessions. Worked on model training, inference integration, and evaluation for real-world AI deployments.",
          color: "#0071C5",
        },
      ],
    },
  ],
};

// Projects Page
const projectsHeader = {
  title: "Projects",
  description:
    "Selected full-stack applications, 3D graphics experiments, and AI systems built for production and hackathons.",
  avatar_image_path: "projects_image.svg",
};

// Contact Page
const contactPageData = {
  contactSection: {
    title: "Let's Connect!",
    profile_image_path: "durvesh_danve.jpg",
    description:
      "Have an engineering role, project, or question? Send a message and I'll get back to you.",
  },
  blogSection: {
    title: "",
    subtitle:
      "Open to hackathon collaborations, technical discussions, and referrals. Feel free to connect on LinkedIn or reach out via email.",
    link: "https://www.linkedin.com/in/durvesh22/",
    avatar_image_path: "blogs_image.svg",
  },
};

const projects = {
  data: [
    {
      name: "DurvOS 98 // 3D Retro Workstation",
      featured: true,
      badge: "Newly Added",
      tagline: "Photorealistic 3D Office & Windows 98 OS",
      url: "https://durvesh-retro-workstation.vercel.app/",
      github: "https://github.com/DurvAcee/durvesh-retro-workstation",
      image: "project-retro-workstation.png",
      description:
        "Immersive 3D retro office room and authentic Windows 98 operating system built with Three.js, WebGL, React 18, and Web Audio API. Features smooth camera flight between desk and screen, real-time CRT phosphor shaders, 1998 Award BIOS memory test bootloader, interactive 3D room objects with spatial audio, and 8 fully functional retro applications (Showcase Explorer, Terminal CLI, Media Player, Minesweeper 98, Paint, Resume Viewer, and Display Settings).",
      highlights: [
        "Photorealistic 3D room with smooth camera lerping & CRT shader",
        "Authentic Windows 98 desktop OS with 8 interactive apps",
        "Spatial Web Audio synthesizer & 6-track retro radio",
        "1998 Award BIOS boot loader with RAM check & GLTF preloading",
      ],
      languages: [
        {
          name: "Three.js / WebGL",
          iconifyClass: "logos-threejs",
        },
        {
          name: "React",
          iconifyClass: "logos-react",
        },
        {
          name: "Tailwind CSS",
          iconifyClass: "logos-tailwindcss-icon",
        },
        {
          name: "Framer Motion",
          iconifyClass: "logos-framer",
        },
        {
          name: "Web Audio API",
          iconifyClass: "simple-icons:audacity",
        },
      ],
    },
    {
      name: "Neon Overdrive // 2088",
      featured: false,
      badge: "3D Game",
      tagline: "3D Cyberpunk WebGL Racing Engine",
      url: "https://try-neon-overdrive.vercel.app/",
      image: "project-neon-overdrive.png",
      description:
        "3D cyberpunk arcade racing game running in the browser. Built with Three.js, WebGL, Web Audio API, and custom vehicle physics. Features slip-angle drift mechanics, procedural city grid across 4 districts, 3 game modes (Cyber Cruise, Heat Wave Survival, Drift Attack), synthwave radio visualizer, and custom garage upgrades.",
      highlights: [
        "Slip-angle drift physics & counter-steering",
        "Procedural 4-district infinite city grid",
        "Web Audio synthesizer RPM & synthwave radio",
        "3 game modes + 5 customizable vehicles",
      ],
      languages: [
        {
          name: "Three.js / WebGL",
          iconifyClass: "logos-threejs",
        },
        {
          name: "React",
          iconifyClass: "logos-react",
        },
        {
          name: "TypeScript",
          iconifyClass: "logos-typescript-icon",
        },
        {
          name: "Tailwind CSS",
          iconifyClass: "logos-tailwindcss-icon",
        },
        {
          name: "Web Audio API",
          iconifyClass: "simple-icons:audacity",
        },
      ],
    },
    {
      name: "Aero Nova - Ultra-Luxury Aviation Experience",
      url: "https://aero-nova-nu.vercel.app/",
      image: "project-aeronova.png",
      description:
        "Interactive 3D scroll-driven web experience for private aviation. Features real-time WebGL aircraft rendering with Three.js, smooth camera flight paths, interactive fleet specs, and dynamic cabin lighting controls.",
      languages: [
        {
          name: "React",
          iconifyClass: "logos-react",
        },
        {
          name: "Three.js / WebGL",
          iconifyClass: "logos-threejs",
        },
        {
          name: "Tailwind CSS",
          iconifyClass: "logos-tailwindcss-icon",
        },
        {
          name: "Framer Motion",
          iconifyClass: "logos-framer",
        },
        {
          name: "TypeScript",
          iconifyClass: "logos-typescript-icon",
        },
      ],
    },
    {
      name: "Pokédex OS",
      url: "https://pokedex-interactive.vercel.app/",
      github: "https://github.com/DurvAcee/pokedex",
      image: "project-pokedex.png",
      description:
        "Tactical National Pokédex database OS indexing all 1,025 Pokémon across 9 generations with live cries and waveform synthesizer. Features an interactive 18×18 type damage matrix, multi-branch evolution visualization, head-to-head battle comparator with base speed tiers, physical height scales, and a 6-squad team builder with real-time shared vulnerability analysis.",
      languages: [
        {
          name: "React",
          iconifyClass: "logos-react",
        },
        {
          name: "TypeScript",
          iconifyClass: "logos-typescript-icon",
        },
        {
          name: "Tailwind CSS",
          iconifyClass: "logos-tailwindcss-icon",
        },
        {
          name: "Framer Motion",
          iconifyClass: "logos-framer",
        },
        {
          name: "Web Audio API",
          iconifyClass: "simple-icons:audacity",
        },
      ],
    },
    {
      name: "Second Brain",
      url: "https://github.com/DurvAcee/second-brain",
      image: "project-second-brain.png",
      description:
        "Privacy-first RAG application integrating a locally-hosted LLM (Ollama) with ONNX MiniLM embeddings and ChromaDB vector storage to index Obsidian notes. Supports natural-language queries with real-time SSE streaming and intent classification to route conversational vs. retrieval requests, fully local, zero cloud dependencies. Features a responsive chat UI with multi-session history, streaming token rendering, and source attribution with deep links to open notes directly in Obsidian.",
      languages: [
        {
          name: "Python",
          iconifyClass: "logos-python",
        },
        {
          name: "FastAPI",
          iconifyClass: "simple-icons:fastapi",
        },
        {
          name: "ChromaDB",
          iconifyClass: "simple-icons:chroma",
        },
        {
          name: "Ollama",
          iconifyClass: "simple-icons:ollama",
        },
        {
          name: "React",
          iconifyClass: "logos-react",
        },
      ],
    },
    {
      name: "Coordinated Attack Detection (CAD)",
      url: "https://cad-intelligence.vercel.app/",
      image: "project-cad.png",
      description:
        "Cybersecurity platform that detects coordinated attacks on backup infrastructure using a dual-stream GNN and temporal encoder pipeline. Includes SHAP explainability, automated SOC alerts, and an interactive D3.js graph dashboard. Awarded 2nd place out of 175+ teams at the Cohesity Hackathon.",
      languages: [
        {
          name: "Python",
          iconifyClass: "logos-python",
        },
        {
          name: "PyTorch",
          iconifyClass: "logos-pytorch-icon",
        },
        {
          name: "FastAPI",
          iconifyClass: "simple-icons:fastapi",
        },
        {
          name: "Neo4j",
          iconifyClass: "simple-icons:neo4j",
        },
        {
          name: "React",
          iconifyClass: "logos-react",
        },
        {
          name: "D3.js",
          iconifyClass: "logos-d3",
        },
      ],
    },
  ],
};

const blogsHeader = {
  title: "Writing",
  description:
    "Technical articles, deep-dives, and guides on AI/LLMs, software architecture, and developer productivity.",
};

const blogs = {
  data: [
    {
      title: "Use any LLM with Just 8 Lines of Code",
      url:
        "https://dev.to/durvesh_danve/build-a-llm-in-just-8-lines-of-code-ld1",
      description:
        "Step-by-step guide to loading, prompting, and running open-source LLMs (Falcon, Llama) using Python, LangChain, and Hugging Face Hub.",
      tags: ["LLM", "AI", "Python", "LangChain"],
      date: "Aug 2024",
      readTime: "3 min read",
      platform: "DEV Community",
    },
    {
      title: "14 JavaScript One-Liners to Boost Your Productivity",
      url:
        "https://dev.to/durvesh_danve/14-javascript-one-liners-to-boost-your-productivity-30m9",
      description:
        "Handpicked modern JavaScript one-liners covering array manipulation, deduplication, object operations, and productivity utilities.",
      tags: ["JavaScript", "Node.js", "WebDev", "Productivity"],
      date: "Aug 2024",
      readTime: "4 min read",
      platform: "DEV Community",
    },
  ],
};

const awardsHeader = {
  title: "Awards & Publications",
  description:
    "Academic merit honors, competitive algorithmic achievements, and peer-reviewed research publications.",
};

const awards = {
  data: [
    {
      title: "1st Ranker's Scholarship",
      issuer: "MIT World Peace University",
      url: "https://mitwpu.edu.in/",
      logo_path: "mit-wpu.png",
      date: "2020 - 2022",
      type: "Academic Honor",
      metrics: ["1st Rank M.Sc. CS '22", "Merit Scholarship"],
      description:
        "Awarded University Merit Scholarship for securing 1st Rank across the entire M.Sc. Computer Science cohort ('22).",
    },
    {
      title: "2nd Rank in CodeGuru Java Competition",
      issuer: "Technocrat / MIT World Peace University",
      url: "https://mitwpu.edu.in/",
      logo_path: "mit-wpu.png",
      date: "2020 - 2022",
      type: "Algorithmic Contest",
      metrics: ["2nd Place Finalist", "Java Algorithms"],
      description:
        "Secured 2nd Rank in the Technocrat CodeGuru Java Competition organized by MIT World Peace University.",
    },
    {
      title: "Study of Voice Controlled Personal Assistants",
      issuer: "IJSRCSEIT Journal",
      url: "https://ijsrcseit.com/CSEIT21829",
      logo_path: "ijs.png",
      date: "2020 - 2022",
      type: "Research Publication",
      metrics: ["Peer-Reviewed", "IJSRCSEIT Paper"],
      description:
        "Authored and published peer-reviewed research paper in the International Journal of Scientific Research in Computer Science, Engineering and Information Technology.",
    },
  ],
};

export {
  settings,
  greeting,
  socialMediaLinks,
  skills,
  degrees,
  certifications,
  experience,
  projectsHeader,
  contactPageData,
  projects,
  blogsHeader,
  blogs,
  awardsHeader,
  awards,
};
